import { AxiosResponseHeaders } from 'axios';
import { isEmpty } from '@dxb-web-ui-framework/common/utils/Helper';
import { Currency, CurrencyResponseDTO } from '../entities';

const currencyDTOToCurrencyAdapter = (data: CurrencyResponseDTO, headers?: AxiosResponseHeaders): Currency[] => {
  if (!data.body) {
    throw new Error('Error');
  }

  const { currencies } = data.body;

  if (isEmpty(currencies)) {
    return [];
  }

  return currencies;
};

export { currencyDTOToCurrencyAdapter };
